<template>
     <div class="bottom_100">
        <div class="bottom_center">
            <div class="bt_le">
                <img src="../../assets/logo.png">
                <span>Copyright © 2018{{$t('m.com')}}</span>
            </div>
            <div class="bt_rg">
                <span>{{$t('m.home')}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{$t('m.about_us')}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{$t('m.service_intro')}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{$t('m.contact_us')}} </span>
            </div>
            <div class="clear"></div>
            <div class="copy">
                <span>粤ICP备15100174号</span>
                <ol>{{$t('m.operating_hours')}}：AM09:00 - PM18:00</ol>
                <div class="clear"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {

}
</script>
<style>
.bottom_100{ width:100%; background:#27272b; height:164px; margin-top:90px; font-size:11px;}
.bottom_center{ width:980px; margin:0 auto; padding-top:56px;}
.bt_le{ float:left;}
.bt_le span{ font-size:11px; color:#69696a; display:block; margin-top:10px;}
.bt_rg{ float:right;}
.bt_rg span{ color:#69696a; display:block; margin-top:43px;}
.copy{ border-top:1px solid #323236; margin-top:16px; line-height:35px;}
.copy span{ float:left;  color:#69696a; display:block;}
.copy ol{ float:right;  color:#69696a; display:block;}
</style>

